import React, { Component } from 'react';
import { escape } from 'lodash/fp';
import ElementBase from '../base';
import CaptionFooter from '../caption';
import ViewFinder from '../shared/ViewFinder';
import Dropzone from '../shared/Dropzone';

const SUPPORTED_IMAGE_EXTENSIONS_RE = /\.(gif|jpg|jpeg|png|bmp)$/i;
const MAX_FILE_SIZE = 50 * 1024 * 1024;

class ImageElement extends Component {
  constructor(props) {
    super(props);
    this.state = { uploading: false };
    this.updateCaption = this.updateCaption.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
  }

  updateCaption(caption) {
    this.props.applyChanges({ caption: escape(caption) });
    this.props.handleUpdate({ caption: escape(caption) });
  }

  handleImageChange(image) {
    if (
      image instanceof File &&
      !SUPPORTED_IMAGE_EXTENSIONS_RE.test(image.name)
    ) {
      // eslint-disable-next-line no-alert
      alert(t('lessons.editor.image.upload_file_type_error'));
      return;
    }

    if (image.size > MAX_FILE_SIZE) {
      // eslint-disable-next-line no-alert
      alert(t('lessons.editor.image.upload_file_size_error'));
      return;
    }

    const { handleImageChange } = this.props;
    this.setState({ uploading: true }, () => {
      handleImageChange(image)
        .then(responseMetadata => {
          this.setState({ uploading: false });
          this.props.toggleAddToImageLibrary(responseMetadata.image);
        })
        .catch(e => {
          console.error(e);
          this.setState({ uploading: false });
        });
    });
  }

  getUploaderProps() {
    return {
      id: this.props.id,
      onUpload: this.handleImageChange,
      uploading: this.state.uploading,
    };
  }

  renderBody() {
    const { image } = this.props.content;
    return !image ? (
      <Dropzone {...this.getUploaderProps()} />
    ) : (
      <ViewFinder {...this.getUploaderProps()} {...this.props.content} />
    );
  }

  render() {
    const { caption } = this.props.content;
    return (
      <div className="EditorElement-content">
        <div className="EditorElement-body">
          <div className="EditorElement-fileHandler">{this.renderBody()}</div>
        </div>
        <CaptionFooter onChange={this.updateCaption} caption={caption} />
      </div>
    );
  }
}

export default ElementBase(ImageElement);
